import i18next from "i18next";

import translationsEN from "@/../public/locales/en.json";
import { mapLocaleToLanguage } from "@/utils/constants";

import { isAttendeesPage } from "./is-attendees-page";

const isBrowser = typeof window !== "undefined";

/**
 * Upon i18next initialization will append custom translations, based on
 * the current language, to the CKEditor global dicitionary
 */
export const initCKEditorLocalisation = () => {
  if (isAttendeesPage() || !isBrowser) {
    return;
  }

  i18next.on("initialized", function () {
    loadBundledTranslation();

    const t = i18next.getFixedT(i18next.language);
    const keysToTranslate = Object.keys(translationsEN["ckeditor"] || []);

    const dictionary = keysToTranslate.reduce((acc, key) => {
      const translationKey = `ckeditor.${key}`;

      if (!i18next.exists(translationKey)) {
        return acc;
      }

      return {
        ...acc,
        [key]: t(`ckeditor.${key}`),
      };
    }, {});

    extendDictionary(mapLocaleToLanguage(i18next.language), dictionary);
  });
};

const loadBundledTranslation = () => {
  const lng = mapLocaleToLanguage(i18next.language);
  require(`@hopin-team/ckeditor5-build-hopin/dist/translations/${lng}`);
};

/**
 * Extends CKEditor's translations for a specific language
 * https://ckeditor.com/docs/ckeditor5/latest/framework/deep-dive/ui/localization.html
 */
const extendDictionary = (lng: string, dictionary: Record<string, string>) => {
  // Make sure that the global object is defined. If not, define it.
  window.CKEDITOR_TRANSLATIONS = window.CKEDITOR_TRANSLATIONS || {};
  // Make sure that the dictionary for [lng] translations exist.
  window.CKEDITOR_TRANSLATIONS[lng] = window.CKEDITOR_TRANSLATIONS[lng] || {};
  window.CKEDITOR_TRANSLATIONS[lng].dictionary =
    window.CKEDITOR_TRANSLATIONS[lng].dictionary || {};

  // Extend the dictionary for [lng] translations with your translations:
  Object.assign(window.CKEDITOR_TRANSLATIONS[lng].dictionary, dictionary);
};
